import { useApp } from "@/context/AppContext";
import { LifeBuoy } from "lucide-react";

export default function Footer() {
  const { supportEmail } = useApp();
  const href = `mailto:${supportEmail}?subject=${encodeURIComponent("Project in a Box - I need help")}`;
  return (
    <footer className="mt-16 bg-brand-navy text-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-white/70">© Project in a Box</p>
        <a
          href={href}
          data-testid="footer-support"
          className="inline-flex items-center gap-2 text-sm font-semibold text-white hover:text-brand-orange transition-colors"
        >
          <LifeBuoy className="w-4 h-4" /> Need help? Get Support
        </a>
      </div>
    </footer>
  );
}
